import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { MarketState } from 'src/app/lib/+state/market.reducer';
import { AuthService } from 'src/app/lib/services/auth.service';
import { MainFacade } from 'src/app/pages/main.facade';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { takeUntil } from 'rxjs/operators';
import { ToastService } from 'angular-toastify';
import { environment } from 'src/environments/environment.prod';

var moment = require('moment-timezone');
@Component({
  selector: 'app-missions',
  templateUrl: './missions.component.html',
  styleUrls: ['./missions.component.scss']
})
export class MissionsComponent implements OnInit {
  public nfts$: Observable<any>|undefined;
  public user$: Observable<any>|undefined;
  public allMissions$: Observable<any>|undefined;
  public myMissions$: Observable<any>|undefined;
  public myCrew$: Observable<any>|undefined;
  public filter$: Observable<any>|undefined;
  public myInventory$: Observable<any>|undefined;
  public filteredMissions$: Observable<any>|undefined;
  public modal$: Observable<any>|undefined;
  private destroy$ = new Subject();
  missionItem:any;
  missionToggle:any = 'Crew';
  selectedCrew:any[]=[];
  crewOnMission:any[]=[];
  crewAvailable:any[]=[];
  showDeploy:boolean = false;
  selectedMission:number = 0;
  selectedMissionFull:any;
  missions:any[]=[];
  nfts:any[]=[];
  user:any={};
  filter:any={
    OnMissions:false,
    AllMissions:true,
    AvailableMissions:false,
    Claimable:false
  };
  page:any='home';
  showMissionSuccess:boolean = false;
  customOptions: OwlOptions = {
    items: 3,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 10,
    responsiveRefreshRate: 1000,
    loop:true,
    autoplay:true,
    margin:0,
    autoplaySpeed: 3000,
    smartSpeed: 3000,
    slideTransition: 'linear',
    autoplayHoverPause:true
  };
 
  constructor(@Inject(DOCUMENT) private doc: Document, private store: Store<MarketState>, private mainfacade:MainFacade, private router:Router, private toastr:ToastService,
  private activeRoute:ActivatedRoute) { 
    activeRoute.url.subscribe(
      (params) => { 
        this.page = params[0].path;
        
      });
  }

  ngOnInit(): void {
    this.setObservables();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
  
  setObservables() {
    this.allMissions$ = this.mainfacade.allMissions$;
    this.myMissions$ = this.mainfacade.myMissions$;
    this.nfts$ = this.mainfacade.nfts$;
    this.user$ = this.mainfacade.user$;
    this.filter$ = this.mainfacade.filter$;
    this.myInventory$ = this.mainfacade.myInventory$;
    this.filteredMissions$ = this.mainfacade.filteredMissions$;
    this.modal$ = this.mainfacade.modal$;
    this.allMissions$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.missions = message;
        this.showDeploy = false;
        this.mainfacade.filterMissions(this.filter, message, this.user.Id);
      }
    });

    this.myMissions$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.missions = message;
        this.showDeploy = false;
        this.mainfacade.filterMissions(this.filter, message, this.user.Id);
        this.runFilters(message)
      }
    });

    this.filter$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.filter = message;

        if(this.missions.length> 0){
  
          this.mainfacade.filterMissions(this.filter, this.missions, this.user.Id);
        }
        
      }
    });


    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.user = message;
        this.page === 'missions' || this.page === 'profile'? this.mainfacade.getMyMissions(this.user.Id) :this.mainfacade.getAllMissions();
      }
    });

    this.nfts$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.nfts = message;
        
      }
    });

    this.filteredMissions$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
      if(message){
        this.crewOnMission=[];
        message.forEach((mis)=>{
          mis.MissionCrew.forEach((misC)=>{
            this.crewOnMission.push(misC);
          })
        })
        
      }
    });

    
  }

  runFilters(missions){
    let onMission = missions.filter((ms)=>{
     
      return !ms.HasEnded;
    }).length;

    let claimable = missions.filter((ms)=>{
      let failed = ms.MissionCrew.find((val)=>{
        return val.Failed;
      })

      return !ms.Claimed  && ms.HasEnded && (!failed || failed == undefined);
    }).length;
    this.mainfacade.setMyMissionDetails(onMission, claimable);
  }

  addCrew(token, contract, nft){

    let found = this.selectedCrew.findIndex((val)=>{
      return val.token.toLowerCase() === token.toLowerCase() && contract.toLowerCase() === val.contract.toLowerCase();
    });
    
    if(found!== -1){
      this.selectedCrew.splice(found,1);
    }
    else{
      let newCrew = {
        token:token,
        contract:contract,
        url:nft.Image,
        missionId:this.selectedMission,
        userId:this.user.Id
      };
      this.selectedCrew.push(newCrew);
    }
  }

  addItem(item){
    if(this.missionItem?.Id === item?.Id){
      this.missionItem=null;
      return;
    }
    this.missionItem = item;
  }

  isSelected(token,contract){
    return this.selectedCrew.find((val)=>{
      return val.token.toLowerCase() === token.toLowerCase() && contract.toLowerCase() === val.contract.toLowerCase();
    });
  }

  checkInMission(crew){
    return crew.find((val)=>{
      return Number(val.UserId) === Number(this.user.Id);
    });
  }

  startDeploy(mission){
    this.selectedCrew = [];
    this.setAvailableCrew();
    this.showDeploy=true;
    this.mainfacade.getMyInventory(this.user.Id);
    this.selectedMissionFull = mission;
    this.selectedMission = mission.MissionId;
  }

  checkContractRestrict(ContractAddress, token_address){
    console.log(ContractAddress)
    console.log(token_address)
    if(ContractAddress){
      return ContractAddress.toLowerCase() === token_address.toLowerCase();
    }
    else {
      return true;
    }
    
  }

  closeModal(){
    this.mainfacade.closeModal();
  }

  deploy(){
  
    if(this.selectedCrew.length <= 0){
      this.toastr.error('Please select at least on soldier.');
      return;
    }


    //Deploy Crew
    this.mainfacade.deploy(this.user.Id, this.selectedCrew, this.missionItem);
    this.missionItem = null;
  }

  desert(missionId){
    this.mainfacade.desert(this.user.Id, missionId);
  }

  previewDeploy(){
    this.selectedCrew =[];
  }

  updateMissions(){

  }

  timedUpdateMissions(){

  }

  claim(missionId){
    this.mainfacade.claim(this.user.Id, missionId);
  }

  route(path){
    this.router.navigateByUrl(path)
  }

  setAvailableCrew(){
    this.crewAvailable = this.nfts.filter((nft)=>{
      let inMission = this.crewOnMission.find((mis)=>{
        return mis.TokenId == nft.token_id && !mis.Completed && !mis.Failed && mis.TokenContract === nft.token_address;
      })
      console.log(nft)
      let unopened = nft.token_address.toLowerCase() !== environment.pack.toLowerCase() ? true : (nft?.Opened?true:false);
 
      return !inMission && unopened;
    })
  }

}
